import { IMAGES, ALBUM_TITLE, SPOTIFY_ALBUM_URL } from "./siteData";

export const Hero = () => (
  <header id="top" data-testid="hero-section" className="py-20 md:py-28 px-6 border-b border-[#1e2335] relative isolate">
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7 space-y-6">
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#181a27] border border-[#2c324c] text-[11px] font-mono-code text-[#a5b4fc] d1-reveal d1-del-1"
        >
          <span className="w-2 h-2 rounded-full bg-[#6366f1] animate-pulse"></span>
          <span>DISPONIBILE PER CORTI &amp; CINEMA INDIPENDENTE</span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-disp font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-[62px] leading-[0.98] tracking-tight text-white"
        >
          <span className="ln"><span>COLONNE SONORE</span></span>
          <span className="ln">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#818cf8] via-[#c084fc] to-[#f472b6]">
              ELETTRONICHE
            </span>
          </span>
          <span className="ln"><span>PER VISIONI CINEMATOGRAFICHE</span></span>
        </h1>

        <p
          data-testid="hero-differentiator"
          className="font-serif-body text-base md:text-lg text-[#94a3b8] max-w-xl leading-relaxed d1-reveal d1-del-2"
        >
          Molta esperienza nel sound design elettronico: un suono originale e riconoscibile, costruito in anni di
          lavoro, per registi e cortometraggi che cercano un'identit&agrave; unica.
        </p>

        <div className="flex flex-wrap items-center gap-4 pt-2 d1-reveal d1-del-3">
          <a
            href="#contact"
            data-testid="hero-cta-commission"
            className="px-7 py-3.5 rounded-xl bg-[#6366f1] text-white text-sm font-disp font-bold shadow-lg shadow-indigo-950/60 hover:bg-[#4f46e5] transition-colors"
          >
            Richiedi Colonna Sonora
          </a>
          <a
            href="#portfolio"
            data-testid="hero-cta-listen"
            className="px-6 py-3.5 rounded-xl border border-[#2d334d] text-white text-sm font-disp font-medium hover:bg-[#161926] transition-colors"
          >
            Ascolta l'Album (17 Tracce)
          </a>
        </div>

        <div data-testid="hero-stats" className="grid grid-cols-3 gap-4 pt-6 border-t border-[#1e2335] d1-reveal d1-del-4">
          <div>
            <div className="text-2xl font-bold font-disp text-white">17</div>
            <div className="text-[11px] font-mono-code text-[#64748b]">TRACCE PUBBLICATE</div>
          </div>
          <div>
            <div className="text-2xl font-bold font-disp text-white">DistroKid</div>
            <div className="text-[11px] font-mono-code text-[#64748b]">DISTRIBUZIONE SPOTIFY</div>
          </div>
          <div>
            <div className="text-2xl font-bold font-disp text-white">Graphic Des.</div>
            <div className="text-[11px] font-mono-code text-[#64748b]">LAUREA IN DESIGN</div>
          </div>
        </div>
      </div>

      <div className="lg:col-span-5 relative">
        <div
          data-testid="hero-visual"
          className="d1-photo-wipe relative rounded-2xl overflow-hidden border border-[#333a56] shadow-2xl bg-[#111320] aspect-[4/5] flex flex-col justify-between"
        >
          <img
            src={IMAGES.heroCover}
            alt="Sintetizzatori modulari con cavi patch luminosi"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080912] via-[#080912]/40 to-transparent"></div>

          <div className="relative z-10 flex items-center justify-between text-xs font-mono-code text-[#c7d2fe] p-6">
            <span>MODULAR RIG &bull; 96kHz / 24bit</span>
            <span className="px-2 py-0.5 rounded bg-black/40 border border-indigo-500/30">MONITOR ACTIVE</span>
          </div>

          <div className="relative z-10 my-auto px-6">
            <svg className="w-full h-24 text-indigo-400/90" viewBox="0 0 300 80" fill="none" aria-hidden="true">
              <path d="M0 40 Q20 10 40 40 T80 40 T120 70 T160 10 T200 60 T240 20 T280 50 T300 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M0 40 Q30 60 60 40 T120 20 T180 55 T240 30 T300 40" stroke="#c084fc" strokeWidth="1.5" strokeDasharray="4 2" opacity="0.7" />
            </svg>
          </div>

          <div className="relative z-10 m-6 mt-0 bg-black/60 backdrop-blur-md p-4 rounded-xl border border-white/10 space-y-1">
            <div className="text-xs font-mono-code text-[#cbd5e1] flex justify-between gap-3">
              <span className="truncate">ALBUM: {ALBUM_TITLE.toUpperCase()}</span>
              <span className="text-emerald-400 shrink-0">SU SPOTIFY</span>
            </div>
            <a
              href={SPOTIFY_ALBUM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-album-link"
              className="text-[11px] text-[#a5b4fc] font-mono-code hover:text-white transition-colors"
            >
              Apri l'album su Spotify &rarr;
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
);
